<template>
    <section class="arrival-photo" aria-label="本人预约到场照片">
        <p v-if="loading" role="status">正在授权读取到场照片…</p>
        <template v-if="url"
            ><img
                :src="url"
                alt="本服务创作者登记的到场现场照片"
                referrerpolicy="no-referrer"
                @error="photoFailed"
            /><button type="button" @click="hide">隐藏照片</button></template
        >
        <div v-if="error" role="alert">
            <p>{{ error }}</p>
            <button type="button" @click="load">重新读取照片</button>
        </div>
    </section>
</template>
<script>
import request from "@/tool/request";
import API from "@/tool/api";
import { unwrapResult, getResultMessage } from "@/tool/result";
export default {
    name: "ArrivalPhoto",
    props: {
        serviceOrderNo: { type: String, required: true },
        ownerKey: { default: "" },
    },
    data() {
        return { url: "", loading: false, error: "", generation: 0 };
    },
    mounted() {
        window.addEventListener("blur", this.hide);
        document.addEventListener("visibilitychange", this.hide);
        this.load();
    },
    beforeDestroy() {
        this.hide();
        window.removeEventListener("blur", this.hide);
        document.removeEventListener("visibilitychange", this.hide);
    },
    watch: {
        ownerKey() {
            this.hide();
        },
        serviceOrderNo() {
            this.hide();
            this.load();
        },
    },
    methods: {
        hide() {
            this.generation += 1;
            this.url = "";
            this.error = "";
            this.loading = false;
        },
        photoFailed() {
            this.hide();
            this.error = "照片读取失败或授权已过期，请重新读取";
        },
        async load() {
            this.hide();
            const generation = this.generation;
            const no = this.serviceOrderNo;
            this.loading = true;
            try {
                const facts = unwrapResult(
                    await request.get(API.photography.userFulfillment(no), {
                        headers: { "Cache-Control": "no-store" },
                    }),
                    "到场信息读取失败"
                );
                if (generation !== this.generation) return;
                if (!facts || facts.serviceOrderNo !== no || !facts.arrivalId)
                    throw new Error("暂无可读取的到场照片");
                const photo = unwrapResult(
                    await request.post(
                        API.photography.userArrivalPhotoAccess(
                            no,
                            facts.arrivalId
                        ),
                        null,
                        { headers: { "Cache-Control": "no-store" } }
                    ),
                    "照片授权失败"
                );
                if (generation !== this.generation) return;
                if (!photo || !/^https?:\/\//.test(photo.url))
                    throw new Error("照片授权暂不可用");
                this.url = photo.url;
            } catch (error) {
                if (generation === this.generation)
                    this.error = getResultMessage(error, "到场照片读取失败");
            } finally {
                if (generation === this.generation) this.loading = false;
            }
        },
    },
};
</script>
<style scoped>
.arrival-photo {
    font-size: 12px;
}
.arrival-photo img {
    width: 100%;
    max-width: 280px;
    max-height: 180px;
    object-fit: contain;
    display: block;
    border-radius: 8px;
    margin: 8px 0;
}
button {
    border: 1px solid #e9e9ef;
    background: white;
    color: #6b5dd5;
    padding: 8px 12px;
    border-radius: 100px;
    cursor: pointer;
}
button:focus-visible {
    outline: 2px solid #6b5dd5;
    outline-offset: 3px;
}
</style>
